import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './welcome-screen.module.scss';
import { accountTypeSelector, clearState, fullSignUpInfoSelector, userInfoSelector } from '../../../../stores/slices/sign-up-slice';
import { YellowBell } from '../../../../assets/icons';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ApplicationRoutes } from '../../../../routes';
import { toast } from 'react-toastify';
import { useCompleteRegistrationMutation } from '../../../../service/customer-service-v2';
import { getErrorMessage, handleApiError } from '../../../../utils/error-handler';
import { logIn } from '../../../../stores/slices/current-user-slice';
import { Button } from '../../components';


const WelcomeScreen= ( ) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accountType = useSelector(accountTypeSelector);
  const { signUpId } = useSelector(userInfoSelector);

  const [completeSignup, { isLoading }] = useCompleteRegistrationMutation();

  const handleSignInAndGotoDashboard = async () =>{
    try {
      const response = await completeSignup({ signupId: signUpId }).unwrap();
      dispatch(clearState());
      dispatch(logIn({ token: response.token, refreshToken: response.refreshToken, userType: response.userType }));
      navigate('/dashboard', { replace: true });
      
    } catch (err: any) {
      toast.error(getErrorMessage(err?.data) || t("common.labels.somethingWrong"));
    }
  }

  useEffect(() => {
    if (!accountType || !signUpId) {
       toast.warn(t('auth.web.kindlySignupToAccess'))
      navigate('../signup', { replace: true });
    }
  }, [accountType, signUpId, navigate, t]);



  const getHeading = () => {
    if (accountType === "Corporate") {
      return t('auth.web.welcomeCorporateAccounts');
    }
    return t('auth.web.welcomeFamilyAccounts')
  };

  const getSubtitle = () => {
    if (accountType === "Corporate") {
      return t('auth.web.corporateWelcomeSubtitle');
    }
    return t('auth.web.familyWelcomeSubtitle');
  };

  const getPrimaryButtonText = () => {
    return accountType === "Corporate"
      ? t('auth.web.setUpCorporateAccount')
      : t('auth.web.setUpFamilyAccount');
  };


  return (
    <div className={styles.container}>
      <button disabled={isLoading} className={styles.closeButton} onClick={handleSignInAndGotoDashboard} aria-label={t('auth.web.close')}>
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <YellowBell />
        </div>

        <h1 className={styles.heading}>
          {getHeading()}
        </h1>

        <p className={styles.subtitle}>
          {getSubtitle()}
        </p>

        <div className={styles.buttonGroup}>
          <Button 
            variant="primary" 
            fullWidth 
            disabled={isLoading}
            onClick={handleSignInAndGotoDashboard}
          >
            {getPrimaryButtonText()}
          </Button>
          
          <Button 
            variant="secondary" 
            fullWidth
            disabled={isLoading} 
            onClick={handleSignInAndGotoDashboard}
          >
            {t('auth.skipForNow')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;